import React from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Box, Typography, Divider, Avatar, Button } from '@mui/material';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InsightsIcon from '@mui/icons-material/Insights';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';

const navItems = [
  { label: 'Sales', icon: <PointOfSaleIcon color="primary" /> },
  { label: 'Inventory', icon: <Inventory2Icon color="primary" /> },
  { label: 'Unpaid Bills', icon: <ReceiptLongIcon color="warning" /> },
  { label: 'Customers', icon: <PeopleIcon color="primary" /> },
  { label: 'Dealers', icon: <BusinessIcon color="primary" /> },
  { label: 'Stock Purchase', icon: <LocalShippingIcon color="success" /> },
  { label: 'Transactions', icon: <ReceiptLongIcon color="primary" /> },
  { label: 'Cashier Sessions', icon: <AccessTimeIcon color="primary" /> },
  { label: 'Reports', icon: <InsightsIcon color="primary" /> },
  { label: 'Settings', icon: <SettingsIcon color="primary" /> },
];

function Sidebar(props) {
  const { cashierName = 'Cashier', onLogout, onNav, active, user } = props;

  return (
    <Drawer
      variant="permanent"
      PaperProps={{
        sx: {
          width: { xs: 64, sm: 180, md: 220, lg: 260 },
          minWidth: 56,
          maxWidth: 300,
          bgcolor: '#fff',
          boxShadow: 3,
          borderRight: '1px solid #eee',
          transition: 'width 0.2s',
        }
      }}
    >
      <Box sx={{ p: 3, borderBottom: '1px solid #eee' }}>
        <Typography variant="h5" fontWeight={700} color="primary.main">POS System</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Cashier: {cashierName}</Typography>
      </Box>
      <List sx={{ flex: 1 }}>
        {navItems.map((item, idx) => (
          <ListItem
            key={item.label}
            button
            selected={active === item.label}
            onClick={() => onNav(item.label)}
            sx={{ borderRadius: 2, mx: 1, my: 0.5, bgcolor: item.label === 'Unpaid Bills' && active === 'Unpaid Bills' ? '#fffbe6' : undefined,
              '&.Mui-selected': item.label === 'Unpaid Bills' ? { bgcolor: '#fffbe6', color: 'warning.main', fontWeight: 700 } : {},
              '&:hover': item.label === 'Unpaid Bills' ? { bgcolor: '#fffbe6' } : {}
            }}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
      <Box sx={{ p: 2, borderTop: '1px solid #eee' }}>
        <Button
          variant="outlined"
          color="error"
          startIcon={<LogoutIcon />}
          fullWidth
          onClick={onLogout}
        >
          Logout
        </Button>
      </Box>
    </Drawer>
  );
}

export default Sidebar;
